export default "__VITE_ASSET__484225f9__"